import { motion } from "framer-motion";
import { Phone, Sparkles } from "lucide-react";
import { SITE, telLink, whatsappLink } from "../lib/site";

export const WhatsAppFloat = () => (
  <div className="fixed bottom-5 right-5 z-40 flex flex-col items-end gap-3">
    <motion.button
      onClick={() => window.dispatchEvent(new Event("ul:chat-toggle"))}
      data-testid="chat-widget-button"
      aria-label="Open AI legal assistant"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.85, duration: 0.5 }}
      whileHover={{ y: -3 }}
      className="group flex items-center gap-3 rounded-full bg-gold py-3 pl-4 pr-5 text-navy shadow-[0_18px_45px_-12px_rgba(154,128,67,0.55)] transition-colors duration-300 hover:bg-gold-light"
    >
      <Sparkles size={17} />
      <span className="text-xs font-semibold tracking-wide">
        Ask the AI
        <span className="block text-[10px] font-normal text-navy/60">
          General legal information
        </span>
      </span>
    </motion.button>
    <motion.a
      href={telLink}
      data-testid="floating-phone-call-button"
      aria-label={`Call ${SITE.phoneDisplay}`}
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 2, duration: 0.5 }}
      className="flex h-11 w-11 items-center justify-center rounded-full border border-navy/15 bg-white text-navy shadow-lg transition-all duration-300 hover:border-gold hover:text-gold-dark"
    >
      <Phone size={17} />
    </motion.a>
    <motion.a
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="Enquire on WhatsApp"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 2.15, duration: 0.5 }}
      whileHover={{ y: -3 }}
      className="group flex items-center gap-3 rounded-full bg-navy py-3 pl-4 pr-5 text-white shadow-[0_18px_45px_-12px_rgba(11,21,40,0.55)] ring-1 ring-white/10 transition-colors duration-300 hover:bg-navy-surface"
    >
      <svg viewBox="0 0 24 24" className="h-5 w-5 fill-gold" aria-hidden="true">
        <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21 5.46 0 9.91-4.45 9.91-9.91C21.95 6.45 17.5 2 12.04 2zm0 18.12c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.26 8.26 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24 4.54 0 8.24 3.7 8.24 8.24 0 4.55-3.7 8.24-8.24 8.24zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.25-.64.8-.78.97-.14.16-.29.18-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.01-.38.11-.51.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.25.25-.85.83-.85 2.02 0 1.19.87 2.34 1 2.5.12.17 1.71 2.61 4.14 3.66.58.25 1.03.4 1.39.51.58.19 1.11.16 1.53.1.47-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.14-1.18-.06-.12-.22-.18-.47-.31z" />
      </svg>
      <span className="text-xs font-semibold tracking-wide">
        WhatsApp us
        <span className="block text-[10px] font-normal text-white/50">
          Typical enquiry, no documents
        </span>
      </span>
    </motion.a>
  </div>
);
